(function() {
  function applyOverride(widget) {
    if (widget._isOverridden) return;
    widget._isOverridden = true;
    // Đè lại hàm update UI để ẩn/hiện widget & cập nhật số lượng đếm
    const originalUpdateAllOfferCardsUI = widget.updateAllOfferCardsUI;
    widget.updateAllOfferCardsUI = async function() {
      // Gọi hàm gốc để cập nhật các class trạng thái và thanh progress bar
      await originalUpdateAllOfferCardsUI.apply(this, arguments);
      // Đếm số lượng offer đã đạt điều kiện (Được bảo vệ bằng try-catch)
      let metCount = 0;
      this.offers.forEach(offer => {
        try {
          const state = this.getOfferState(offer.id, offer.module);
          if (state && state.conditionState !== this.CONDITION_STATE.NOT_MET) {
            metCount++;
          }
        } catch (e) {
          console.warn("GIC Override - Không thể lấy trạng thái offer:", e);
        }
      });
      // Cập nhật lại số đếm ở header
      const offerNumberElements = document.querySelectorAll(".salepify-gic__offer-number");
      const generalTranslation = this.translations?.general || this.GENERAL_TRANSLATION.general;
      let offerNumberText = generalTranslation.offer_number || "";
      offerNumberText = this.utils.replaceVariable(offerNumberText, "{{offer_counts}}", String(metCount));
      offerNumberElements.forEach((el) => {
        el.textContent = offerNumberText;
      });
      // Ẩn toàn bộ widget GIC nếu không có offer nào đạt điều kiện
      const gicContainers = document.querySelectorAll(".salepify-gic__gic-container");
      if (metCount === 0) {
        gicContainers.forEach(container => {
          container.style.setProperty("display", "none", "important");
        });
      } else {
        gicContainers.forEach(container => {
          container.style.removeProperty("display");
        });
      }
      this.setupOfferScroll();
    };
    // Đè thêm hàm addOffersToWidget để chạy hàm cập nhật ngay sau khi render xong
    const originalAddOffersToWidget = widget.addOffersToWidget;
    widget.addOffersToWidget = async function(offers) {
      await originalAddOffersToWidget.apply(this, arguments);
      await this.updateAllOfferCardsUI();
    };
  }
  // Lắng nghe sự kiện click trên toàn bộ card để mở popup chọn quà
  document.addEventListener('click', function(e) {
    // Chỉ kích hoạt khi click vào card đã đạt điều kiện
    const card = e.target.closest('.salepify-gic__offer-card--met_before_claim, .salepify-gic__offer-card--met_after_claim');
    if (card) {
      if (e.target.closest('.salepify-gic__progress')) return;
      if (e.target.closest('a') || e.target.closest('button')) return;
      const modal = document.querySelector(".salepify-gic__gift-selector-modal");
      if (modal && modal.open) return;
      const ruleKey = card.getAttribute('data-rule-key');
      if (ruleKey && window.tlGiftInCartWidget) {
        const offer = window.tlGiftInCartWidget.offers.find(o => 
          window.tlGiftInCartWidget.utils.getRuleKey(o.id, o.module) === ruleKey
        );
        if (offer) {
          window.tlGiftInCartWidget.toggleGiftSelector(true, offer.id, offer.module);
        }
      }
    }
  });
  // Khởi chạy đè hàm widget (hỗ trợ cả gán trực tiếp và Polling an toàn)
  function init() {
    if (window.tlGiftInCartWidget) {
      applyOverride(window.tlGiftInCartWidget);
      window.tlGiftInCartWidget.updateAllOfferCardsUI();
      return true;
    }
    return false;
  }
  if (!init()) {
    // Thử defineProperty
    try {
      let _widget = undefined;
      Object.defineProperty(window, 'tlGiftInCartWidget', {
        configurable: true,
        enumerable: true,
        get() { return _widget; },
        set(val) {
          _widget = val;
          if (val) {
            applyOverride(val);
          }
        }
      });
    } catch (e) {
      const interval = setInterval(() => {
        if (init()) clearInterval(interval);
      }, 100);
      setTimeout(() => clearInterval(interval), 10000); 
    }
  }
})();